export class GroupAssessment {
  id: string;
  assessmentName: string;
  description: string;
  groupId: string;
  advancement: string;
  assessmentId: string;
  assessmentIsCertifying: boolean;
  expirationDate: Date | string;

  constructor(groupAssessment: Partial<GroupAssessment>) {
    this.id = groupAssessment.id;
    this.assessmentName = groupAssessment.assessmentName ?? '';
    this.description = groupAssessment.description ?? '';
    this.groupId = groupAssessment.groupId;
    this.assessmentId = groupAssessment.assessmentId;
    this.advancement = groupAssessment.advancement;
    this.assessmentIsCertifying = groupAssessment.assessmentIsCertifying;
    this.expirationDate = new Date(groupAssessment.expirationDate);
  }
}
